/* @flow */

import Typenames from './Typenames'
import { ActionTypes, store } from 'store'
import _ from 'lodash'

/**
 * An EsteroAlert is an alert configured to monitor Manatees in Estero.
 * @typedef { Object } EsteroAlert
 * @memberof EsteroAlertService
 */
export type EsteroAlert = {
  id?: String,
  version?: String,
  name: String,
  description?: String,
  hits: Number,
  interval: Number,
  condition: EsteroAlertCondition,
  actions: Array<EsteroAlertAction>
}

export type EsteroAlertCondition = {
  type: String,
  query?: String,
  flow?: String
}

export type EsteroAlertAction = {
  type: String,
  service: String,
  mail?: EsteroMailAction,
  chat?: EsteroChatAction
}

export type EsteroMailAction = {
  to: String,
  subject: String,
  body: String
}

export type EsteroChatAction = {
  channel: String,
  message: String
}

/**
 * EsteroAlert typename
 * @private
 * @memberof EsteroAlertService
 */
const TYPENAME = Typenames.ESTERO_ALERT

const uniqueConstraints = []

/**
 * Creates a new alert.
 * @function
 * @memberof EsteroAlertService
 *
 * @return { Promise<string> } The id of the added alert.
 */
const create = (a: EsteroAlert): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.CREATE, {
    typename: TYPENAME,
    item: a,
    uniqueConstraints: uniqueConstraints
  })
}

/**
 * Reads an estero alert, flattening 'descriptive'.
 * @function
 * @memberof EsteroAlertService
 *
 * @return { Promise<EsteroAlert> } The alert object.
 */
const read = (id: string): Promise<Object> => {
  return store.dispatch(ActionTypes.GET_BY_ID, { typename: TYPENAME, id: id }).then(alert => {
    return { ...alert }
  })
}

/**
 * Updates an alert.
 * @function
 * @memberof EsteroAlertService
 *
 * @return { Promise<any> }
 */
const update = (id: string, a: EsteroAlert): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.UPDATE, {
    typename: TYPENAME,
    id: id,
    item: a,
    uniqueConstraints: uniqueConstraints
  })
}

/**
 * Deletes an alert.
 * @function
 * @memberof EsteroAlertService
 *
 * @return { Promise<any> }
 */
const remove = (id: string): Promise<Object> => {
  return store.dispatch(ActionTypes.DELETE, { typename: TYPENAME, id: id })
}

/**
 * Reads all alerts flattening descriptive.
 * @function
 * @memberof EsteroAlertService
 *
 * @return { Observable<Array<EsteroAlert>> } All the alerts.
 */
const readAll = (): Promise<Object> => {
  return store.dispatch(ActionTypes.GET, TYPENAME).then(alerts => {
    console.debug('alerts', alerts)
    return _.map(alerts, a => {
      return {
        ...a
      }
    })
  })
}

const self = {
  create,
  read,
  update,
  remove,
  readAll
}

/**
 * EsteroAlert service: CRUD interface for estero alerts.
 * @module EsteroAlertService
 * @namespace EsteroAlertService
 * @version 1.0.0
 */
export default self
